(() => {
  const label = document.querySelector('[data-zq-contents-label]')?.textContent;
  if (!label) return;
  document.querySelectorAll('.zeniqas-content-page, .shopify-policy__container').forEach((page, pageIndex) => {
    const content = page.querySelector('.rte, .shopify-policy__body');
    if (!content) return;
    const headings = [...content.querySelectorAll('h2')].filter(heading => heading.textContent.trim());
    if (headings.length < 4 || page.querySelector('.zq-page-contents')) return;
    const contents = document.createElement('details');
    contents.className = 'zq-page-contents';
    const summary = document.createElement('summary');
    summary.textContent = label;
    const navigation = document.createElement('nav');
    navigation.setAttribute('aria-label', label);
    const list = document.createElement('ol');
    headings.forEach((heading, index) => {
      if (!heading.id) heading.id = `zq-page-${pageIndex}-section-${index + 1}`;
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim();
      item.append(link);
      list.append(item);
    });
    navigation.append(list);
    contents.append(summary, navigation);
    content.before(contents);
  });
})();

(() => {
  let scheduled = false;
  let observedChat;
  let observedButton;
  const findChatButton = chat => chat?.shadowRoot?.querySelector('[part~="activator"]') || chat?.shadowRoot?.querySelector('shopify-agent-runtime')?.shadowRoot?.querySelector('[part~="activator"]');
  const resizeObserver = 'ResizeObserver' in window ? new ResizeObserver(() => schedule()) : null;
  const shadowObserver = new MutationObserver(() => schedule());
  const updateChat = () => {
    scheduled = false;
    const chat = document.querySelector('shopify-chat');
    const button = findChatButton(chat);
    if (!chat || !button) return;
    if (chat !== observedChat) {
      observedChat = chat;
      shadowObserver.disconnect();
      shadowObserver.observe(chat.shadowRoot, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-expanded'] });
    }
    if (button !== observedButton) {
      if (observedButton) resizeObserver?.unobserve(observedButton);
      observedButton = button;
      shadowObserver.observe(button.getRootNode(), { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-expanded'] });
      resizeObserver?.observe(button);
    }
    chat.classList.remove('zq-chat-obstructed', 'zq-chat-inline');
    chat.style.removeProperty('--shopify-chat-activator-offset');
    if (button.getAttribute('aria-expanded') === 'true') return;
    const footer = document.querySelector('#ZqApprovedFooter');
    const footerRect = footer?.getBoundingClientRect();
    if (footerRect && footerRect.top < innerHeight && footerRect.bottom > 0) {
      const link = footer.querySelector('[data-zq-inline-chat]');
      const target = link?.getBoundingClientRect();
      const rect = button.getBoundingClientRect();
      const bottomLimit = innerHeight - (document.querySelector('[data-approved-sticky]:not([hidden])') ? 92 : 20);
      if (target && rect.width && target.top >= 0 && target.top + rect.height <= bottomLimit) {
        chat.style.setProperty('--zq-chat-inline-x', '0px');
        chat.style.setProperty('--zq-chat-inline-y', '0px');
        chat.classList.add('zq-chat-inline');
        const origin = button.getBoundingClientRect();
        chat.style.setProperty('--zq-chat-inline-x', `${target.left - origin.left}px`);
        chat.style.setProperty('--zq-chat-inline-y', `${target.top - origin.top}px`);
      } else {
        chat.classList.add('zq-chat-obstructed');
      }
      return;
    }
    const rect = button.getBoundingClientRect();
    if (!rect.width || !rect.height) return;
    const selectors = 'main a, main button, main input:not([type="hidden"]), main select, main textarea, main [role="button"], main h1, main h2, main h3, main p, main li, main label, main [class*="delivery"], main [class*="newsletter"], #ZqApprovedFooter .af-brand, #ZqApprovedFooter .af-newsletter, #ZqApprovedFooter .af-links, #ZqApprovedFooter .af-bottom';
    const controls = [...document.querySelectorAll(selectors)]
      .filter(element => getComputedStyle(element).visibility !== 'hidden')
      .map(element => element.getBoundingClientRect())
      .filter(target => target.width && target.height && target.bottom > 0 && target.top < innerHeight && target.right > rect.left - 16 && target.left < rect.right + 16);
    const blocked = controls.some(target => target.bottom > rect.top - 16 && target.top < rect.bottom + 16);
    chat.classList.toggle('zq-chat-obstructed', blocked);
  };
  function schedule() {
    if (!scheduled) {
      scheduled = true;
      requestAnimationFrame(updateChat);
    }
  }
  document.addEventListener('click', schedule);
  document.addEventListener('scroll', schedule, { passive: true, capture: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('load', schedule, { once: true });
  new MutationObserver(schedule).observe(document.body, { childList: true });
  if (document.fonts?.ready) document.fonts.ready.then(schedule);
  schedule();
})();
